import Button from 'components/Button'
import QuizesList from 'components/QuizList';
import QuizTopicCard from 'components/QuizTopicCard';
import Spinner from 'components/Spinner';
import { useNavigate, useParams } from 'react-router';
import { TOPICS } from 'utils';
import { ReactComponent as BackIcon } from "resources/images/back.svg"

type Props = {}

export default function QuizDetailPage({ }: Props) {
    let navigate = useNavigate();
    let { topic } = useParams();

    console.log("Quiz Detail")
    if (topic === undefined) {
        return <Spinner className='mt-2' />
    }
    return (
        <div className='p-5'>
            <Button onClick={() => navigate("/")}>
                <BackIcon className='mr-2' />
                Back
            </Button>
            <div className='my-5' />
            <QuizTopicCard
                key={topic}
                onPercentObtained={() => { }}
                topic={TOPICS.filter(t => t.topic === topic)[0]}
                getDetail={(quizes) => <QuizesList quizes={quizes} />}
            />
        </div>
    )
}

